import { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { useDebounce } from '../debounce/useDebounce';
import { useForm } from '../forms/useForm';
import { sendRequest } from '../requests/useRequest';
import { validarSesion } from '../tokens/useToken';
import { usePaginationBackend } from '../pagination/usePaginationBackend';
import { getListConfiguration, createPatientDynamic, updatePatientDynamic, updateHistoricalPatient, getViewHistorical } from '../../services/patient/patient';
import ValidateGlobalFormPatient from '../../utils/validations/GlobalpatientValidations';

export const usePatients = () => {

    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [createSweet] = useSweetAlert();

    const [isInvoiceService, setIsInvoiceService] = useState(false);
    const [idPatient, setIdPatient] = useState(0);
    const [viewNewSocialGender, setViewNewSocialGender] = useState(false);

    const [listPatients, setListPatients] = useState([]);
    const [listPatientsData, setListPatientsData] = useState([]);
    const [listStates, setListStates] = useState([]);
    const [listMunicipalities, setListMunicipalities] = useState([]);
    const [listBloodType, setListBloodType] = useState([]);
    const [listTaxRegime, setListTaxRegime] = useState([]);
    const [listUseCfdi, setListUseCfdi] = useState([]);
    const [listSocialGender, setListSocialGender] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");
    const [filters, setFilters] = useState("");
    const debounceValue = useDebounce(searchQuery, 500);
    const [filtersForm, setFiltersForm] = useState(true);

    const [loadingExport, setLoadingExport] = useState(false);

    // ? CONFIGURATION CREATE AND UPDATE PATIENT
    const [fieldErrors, setFieldErrors] = useState({});
    const [listConfiguration, setListConfiguration] = useState([])

    // ? CONFIGURATION HISTORIC PATIENT
    const [originalPatient, setOriginalPatient] = useState(null);
    const [loadingCount, setLoadingCount] = useState(false);

    const toggle = () => {
        setModal(prev => !prev);
        setLoading(false);
        setFieldErrors({})
    };

    const closeModalPatient = () => {
        setModal(false);
    };



    // ? FORM PATIENT 
    const [informationPatient, setInformationPatient] = useState({
        birthday: null,
        is_complete: false,
        phone: null,
        gender: null,
        age: null,
        email: null,
        curp: null,
        membership: null,
        name: null,
        paternal_surname: null,
        maternal_surname: null,
        cardnumber: null,
        id_social_gender: 0,
        setFileINE: "",
        img64FileI: false,
        cp: null,
        id_blood_type: 0,
        id_municipality: 0,
        id_state: 0,
        expedient_number: null,
        nss: null,
        matricula_buap: null,
        whatsapp_numbers: null,

    });

    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues, handlePickerValues, handleDinamicInput, handleDate] = useForm({
        id_gender: 0,
        id_state: 0,
        id_municipality: 0,
        id_blood_type: 0,
        id_social_gender: 0,
        id_tax_regime: 0,
        id_use_cfdi: 0,
        rfc: "",
        type_person: 1,
        code: "",
        paternal_surname: "",
        maternal_surname: "",
        name: "",
        birthday: "",
        age: "",
        curp: "",
        address: "",
        cp: "",
        colony: "",
        phone: "",
        email: "",
        who_collects_exams: "",
        membership: "",
        cardnumber: "",
        new_social_gender: "",
        scan_ine_check: false,
        setFileINE: "",
        img64File: "",
        expedient_number: "",
        nss: "",
        matricula_buap: "",
        whatsapp_numbers: "",

    });

    const {
        id_gender, id_state, id_municipality, id_blood_type, id_social_gender, id_tax_regime,
        id_use_cfdi, rfc, type_person, code, paternal_surname, maternal_surname, name, birthday, curp, age,
        address, cp, colony, phone, email, membership, cardnumber, new_social_gender, matricula_buap, nss, expedient_number, whatsapp_numbers
    } = formValues;



    const { goNextPage, goPreviousPage, goToPage, searchAsync, totalRecords, actualPage, totalPages, prevPage, nextPage, resultCount, results } = usePaginationBackend(
        { method: 'GET' },
        'Patient/ListPatient',
        history,
        searchQuery,
        filters
    );

    //#region GET METHODS
    const getStates = async () => {
        const _list = await _handleRequest("GET", "State/List", "Estados");

        if (_list !== null && _list.length > 0) {

            let _list_states = [];
            _list.forEach(_state => {
                _list_states.push({
                    label: _state.name,
                    value: _state.id_state
                });
            });

            setListStates(_list_states);
        }
        else {
            setListStates([]);
        }
    }

    const getMunicipality = async (_id_state) => {
        const _list = await _handleRequest("GET", `Municipality/List/${_id_state}`, "Municipios");

        if (_list !== null && _list.length > 0) {
            let _list_municipalities = [];

            _list.forEach(_municipality => {
                _list_municipalities.push({
                    label: _municipality.name,
                    value: _municipality.id_municipality
                });
            });

            setListMunicipalities(_list_municipalities);
        }
        else {
            setListMunicipalities([]);
        }
    }

    const getBloodType = async () => {
        const _list = await _handleRequest("GET", "BloodType/List", "Tipo sanguineo");

        if (_list !== null && _list.length > 0) {
            let _list_blood = [];
            _list.forEach(_blood => {
                _list_blood.push({
                    label: _blood.blood_type,
                    value: _blood.id_blood_type
                });
            });

            setListBloodType(_list_blood);
        }
        else {
            setListBloodType([]);
        }
    }

    const getTaxRegime = async (_type_person = 1) => {
        const _list = await _handleRequest("GET", `CfdiCatalog/ListTaxRegime/4.0?${_type_person === 1 ? 'physical_person=true' : 'moral_person=true'}`, 'Régimen fiscal');

        if (_list !== null && _list.length > 0) {
            let _list_tax_regime = [];

            _list.forEach(_tax => {
                _list_tax_regime.push({
                    value: _tax.id_tax_regime,
                    label: _tax.code + " " + _tax.name
                });
            });

            setListTaxRegime(_list_tax_regime);
        }
        else {
            setListTaxRegime([]);
        }
    }

    const getUseCfdi = async (_id_tax_regime, _type_person = 1) => {

        const _list = await _handleRequest("GET", `CfdiCatalog/ListUseCfdi/${_id_tax_regime}/${_type_person === 1 ? true : false}`);

        if (_list !== null && _list.length > 0) {
            let _list_use = [];

            _list.forEach(_use => {
                _list_use.push({
                    label: _use.code + " " + _use.name,
                    value: _use.id_use_cfdi
                });
            });

            setListUseCfdi(_list_use);
        }
        else {
            setListUseCfdi([]);
        }
    }

    const getSocialGender = async () => {
        const _list = await _handleRequest("GET", "SocialGender/List", "Género social");

        if (_list !== null && _list.length > 0) {
            let _list_social_gender = [{
                value: 0,
                label: "OTRO"
            }];

            _list.forEach(_gender => {
                _list_social_gender.push({
                    label: _gender.name_social_gender,
                    value: _gender.id_social_gender
                });
            });

            setListSocialGender(_list_social_gender);
        }
        else {
            setListSocialGender([]);
        }
    }
    //#endregion

    // #region HANDLE PATIENTS
    const handleSearch = (value) => {
        setSearchQuery(value);
    }

    const handleClearFilter = () => {
        setSearchQuery("");
    };

    const handleChangeState = (e) => {
        handleSelectValues(e, "id_state");

        if (e.value !== undefined) {
            let _value = e.value;

            getMunicipality(_value);
        }
    }

    const handleChangeTypePerson = (e) => {

        let _value = e.target.value;

        handleUpdateValues({
            ...formValues,
            id_tax_regime: 0,
            type_person: _value
        });

        getTaxRegime(_value !== '' ? parseInt(_value) : 1);
    }

    const handleChangeTaxRegime = (e) => {

        handleSelectValues(e, "id_tax_regime");

        if (e.value !== undefined) {

            getUseCfdi(e.value, formValues.type_person);
        }
    }

    const handleChangeSocialGender = (e) => {

        handleSelectValues(e, "id_social_gender");

        if (e.value !== undefined) {

            if (e.value === 0) {
                setViewNewSocialGender(true);
            }
            else {
                setViewNewSocialGender(false);
            }
        }
    }
    //#endregion


    // ? CONFIGURATION FORM PATIENT
    const getConfiguration = async () => {
        const _search = await getListConfiguration();

        if (_search?.data.length > 0) {
            const list = _search?.data
                .filter(item => item?.visibility_work_order)
                .map(item => {
                    return {
                        id_field: item?.id_field,
                        field: item?.field,
                        visibility_work_order: item?.visibility_work_order,
                        required_field: item?.required_field,
                        field_name: item?.field_name,
                        historical: item?.historical
                    };
                });

            setListConfiguration(list);
        }
        else createSweet("warning", "warning", "Configuración", "Sin resultados");
    }

    const validationsPatientFormS = () => {

        const { statusValidation, newValidations } =
            ValidateGlobalFormPatient(formValues, listConfiguration);

        setFieldErrors(newValidations);

        return statusValidation;
    };

    // ? CREATE PATIENT
    const handleCreate = () => {
        handleUpdateValues({
            id_gender: 0,
            id_state: 0,
            id_municipality: 0,
            id_blood_type: 0,
            id_social_gender: 0,
            id_tax_regime: 0,
            id_use_cfdi: 0,
            rfc: "",
            type_person: 1,
            code: "",
            paternal_surname: "",
            maternal_surname: "",
            name: "",
            birthday: "",
            age: "",
            curp: "",
            address: "",
            cp: "",
            colony: "",
            phone: "",
            email: "",
            who_collects_exams: "",
            membership: "",
            cardnumber: "",
            new_social_gender: "",
            scan_ine_check: false,
            setFileINE: "",
            img64File: "",
            expedient_number: "",
            study_delivery: "",
            nss: "",
            matricula_buap: "",
            whatsapp_numbers: "",
        });
        setMethod("create");
        setModalTitle("Nuevo paciente");
        getStates();
        getBloodType();
        getTaxRegime();
        getSocialGender();
        setViewNewSocialGender(false);
        getConfiguration()
        toggle();
    }

    const saveCreatePatient = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (validationsPatientFormS()) {
            setLoading(false);
            return;
        }

        try {

            const data = await createPatientDynamic({
                formValuesPatient: formValues,
                listConfiguration,
                handleRequest: _handleRequest
            });

            if (data) {

                handleUpdateValues({
                    ...formValues,
                    id_patient: data.id_patient
                });

                await searchAsync();

                toggle();
                createSweet("create", "success", "Paciente", "Se creó correctamente");
            }

        } catch (error) {
            console.error(error);
        }

        setLoading(false);
    };

    // ? DELETE PATIENT
    const handleDelete = (_id_patient) => {
        let _findPatient = listPatients.find(p => p.id_patient === _id_patient);

        if (_findPatient !== undefined) {
            handleUpdateValues({
                paternal_surname: _findPatient.paternal_surname,
                maternal_surname: _findPatient.maternal_surname,
                name: _findPatient.name
            });

            setIdPatient(_id_patient);
            setMethod("delete");
            setModalTitle("Eliminar paciente");
            toggle();
        }
    }

    const saveDelete = async (e) => {
        e.preventDefault();
        setLoading(true);

        const changes = [
            {
                site: "Catalógo de pacientes",
                url: `/api/Patient/${idPatient}`,
                method: "DELETE",
                id_patient: idPatient,
                action_delete: true
            }
        ];

        try {
            const data = await updateHistoricalPatient({
                modifiedHistoricalFields: changes
            });
            console.log("🚀 ~ saveDelete ~ data:", data)

            const response = await _handleRequest(
                "DELETE",
                `Patient/${idPatient}`,
                "Eliminar paciente"
            );

            if (response !== null) {
                await searchAsync();
                createSweet("delete", "success", "Éxito!", "Paciente eliminado");
                toggle();
            }

        } catch (error) {
            console.error("Error al eliminar paciente:", error);
        }
        setLoading(false);
    };


    // ? INFORMATION PATIENT
    const handleGetInformationPatient = async (id_patient, unique_uuid = 0) => {
        let alternative_methods = "";
        if (unique_uuid !== 0) {
            alternative_methods = `?unique_uuid=${unique_uuid}`;
        }

        let listTmp = await _handleRequest("GET", `Patient/FindPatientId/${id_patient}${alternative_methods}`, 'Paciente');
        if (listTmp != null) {
            let tmpPatient = {
                birthday: listTmp.birthday,
                is_complete: listTmp.is_complete,
                phone: listTmp.phone,
                gender: listTmp.gender,
                age: listTmp.age,
                email: listTmp.email === "null" ? "" : listTmp.email,
                email_patient: listTmp.email,
                curp: (listTmp.curp === null || listTmp.curp === "") ? null : listTmp.curp,
                membership: listTmp.membership,
                name: listTmp.name,
                paternal_surname: listTmp.paternal_surname,
                maternal_surname: listTmp.maternal_surname,
                cardnumber: listTmp.unique_uuid,
                id_social_gender_patient: listTmp.id_social_gender_patient === null ? 0 : {
                    label: listTmp.name_social_gender,
                    value: listTmp.id_social_gender
                },
                scan_ine_check: listTmp.scan_ine_check,
                img64FileI: listTmp.scan_ine_name,
                cp: listTmp.cp,
                name_blood_type: listTmp.name_blood_type,
                colony: listTmp.colony,
                address: listTmp.address,
                id_state: { value: listTmp.id_state_patient, label: listTmp.name_state_patient },
                id_municipality: { value: listTmp.id_municipality_patient, label: listTmp.name_municipality_patient },
                name_state: listTmp.name_state_patient,
                name_municipality: listTmp.name_municipality_patient,
                expedient_number: listTmp.expedient_number,
                study_delivery: listTmp.study_delivery,
                nss: listTmp.nss === null ? "N/D" : listTmp.nss,
                matricula_buap: listTmp.matricula_buap === null ? "" : listTmp.matricula_buap,
                id_blood_type: { value: listTmp.id_blood_type, label: listTmp.name_blood_type },
                whatsapp_numbers: listTmp.whatsapp_numbers === "null" ? "" : listTmp.whatsapp_numbers,

            };

            setInformationPatient(tmpPatient);

            if (unique_uuid !== 0) {

                handleUpdateValues({
                    ...formValues,
                    id_patient: listTmp.id_patient
                });
            }
        }
        else {
            handleUpdateValues({
                ...formValues,
                id_patient: 0
            });

            setInformationPatient({
                birthday: null,
                is_complete: false,
                phone: null,
                gender: null,
                age: null,
                email: null,
                email_patient: null,
                curp: null,
                membership: null,
                cardnumber: null,
                name: null,
                paternal_surname: null,
                maternal_surname: null,
                id_social_gender_patient: 0,
                img64FileI: "",
                cp: null,
                colony: "",
                address: "",
                id_state_patient: 0,
                id_municipality_patient: 0,
                expedient_number: "",
                study_delivery: "",
                nss: null,
                matricula_buap: null,
                whatsapp_numbers: null
            });
        }
    }

    // ? UPDATE PATIENT
    const handleUpdate = (_id_patient) => {
        let _findPatient = listPatients.find(p => p.id_patient === _id_patient);

        if (_findPatient !== undefined) {

            setIdPatient(_id_patient);
            setOriginalPatient(_findPatient);


            handleUpdateValues({
                id_gender: _findPatient.id_gender || null,
                id_state: _findPatient.id_state === null ? 0 : {
                    label: _findPatient.name_state,
                    value: _findPatient.id_state
                },
                id_municipality: _findPatient.id_municipality === null ? 0 : {
                    label: _findPatient.name_municipality,
                    value: _findPatient.id_municipality
                },

                id_blood_type: _findPatient.id_blood_type === null ? 0 : {
                    value: _findPatient.id_blood_type,
                    label: _findPatient.name_blood_type
                },
                id_social_gender: _findPatient.id_social_gender === null ? 0 : {
                    label: _findPatient.name_social_gender,
                    value: _findPatient.id_social_gender
                },
                id_tax_regime: _findPatient.id_tax_regime === null ? 0 : {
                    label: _findPatient.name_tax_regime,
                    value: _findPatient.id_tax_regime
                },
                id_use_cfdi: _findPatient.id_use_cfdi === null ? 0 : {
                    value: _findPatient.id_use_cfdi,
                    label: _findPatient.name_use_cfdi
                },
                rfc: _findPatient.rfc === null ? "" : _findPatient.rfc,
                type_person: _findPatient.type_person,
                paternal_surname: _findPatient.paternal_surname,
                maternal_surname: _findPatient.maternal_surname,
                name: _findPatient.name,
                birthday: _findPatient.birthday,
                age: _findPatient.age,
                curp: _findPatient.curp === null ? "" : _findPatient.curp,
                address: _findPatient.address === null ? "" : _findPatient.address,
                cp: _findPatient.cp,
                colony: _findPatient.colony === null ? "" : _findPatient.colony,
                phone: _findPatient.phone,
                email: _findPatient.email,
                membership: _findPatient.membership === null ? "" : _findPatient.membership,
                cardnumber: "",
                new_social_gender: "",
                matricula_buap: _findPatient.matricula_buap === null ? null : _findPatient.matricula_buap,
                nss: _findPatient.nss,
                expedient_number: _findPatient.expedient_number,
                unique_uuid: _findPatient.unique_uuid,
                whatsapp_numbers: _findPatient.whatsapp_numbers,

            });

            getStates();
            if (_findPatient.id_state !== null) {
                getMunicipality(_findPatient.id_state);
            }

            getTaxRegime(_findPatient.type_person);
            if (_findPatient.id_tax_regime !== null) {
                getUseCfdi(_findPatient.id_tax_regime, _findPatient.type_person);
            }
            getSocialGender();
            getBloodType();
            setMethod("updateData");
            setModalTitle("Editar paciente");
            toggle();
            setViewNewSocialGender(false);
            getConfiguration()
        }
    }

    const saveUpdatePatient = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (validationsPatientFormS()) {
            setLoading(false);
            return;
        }

        let _id = idPatient;

        const getAge = (ageInput) => {
            const today = new Date();

            if (!ageInput) {
                handleUpdateValues({ ...formValues, age: '', birthday: '' });
                return null;
            }

            const isDateFormat = ageInput.split('-').length === 3;

            if (isDateFormat) {
                const [y, m, d] = ageInput.split('-').map((val) => parseInt(val, 10));
                const birthDate = new Date(y, m - 1, d);

                if (
                    birthDate.getFullYear() !== y ||
                    birthDate.getMonth() !== m - 1 ||
                    birthDate.getDate() !== d
                ) {
                    console.error('Fecha inválida');
                    return null;
                }

                let age = today.getFullYear() - y;
                const birthdayThisYear = new Date(today.getFullYear(), m - 1, d);
                if (today < birthdayThisYear) age--;

                return {
                    age,
                    birthday: ageInput
                };

            } else {
                const age = parseInt(ageInput, 10);

                if (!Number.isFinite(age) || age <= 0) {
                    console.error('Edad inválida');
                    return null;
                }

                const birthDate = new Date(
                    today.getFullYear() - age,
                    today.getMonth(),
                    today.getDate()
                );

                const formattedDate = birthDate.toISOString().split('T')[0];

                return {
                    age,
                    birthday: formattedDate
                };
            }
        };

        let updatedValues = { ...formValues };

        if (formValues.birthday !== '') {
            const result = getAge(formValues.birthday);

            if (result) {
                updatedValues = {
                    ...formValues,
                    age: result.age,
                    birthday: result.birthday
                };
            }
        }

        // ? HISTORIC PATIENT
        const modifiedHistoricalFields = getModifiedHistoricalFields(
            originalPatient,
            updatedValues,
            listConfiguration,
            _id
        );

        try {

            const data = await updatePatientDynamic({
                id_patient: _id,
                formValuesPatient: updatedValues,
                listConfiguration,
                handleRequest: _handleRequest
            });

            if (data !== null) {

                if (modifiedHistoricalFields.length > 0) {
                    const data = await updateHistoricalPatient({
                        modifiedHistoricalFields
                    });
                    console.log("🚀 ~ saveUpdatePatient ~ data:", data)
                }


                const name_patient = `${updatedValues.name} ${updatedValues.paternal_surname} ${updatedValues.maternal_surname} - ${updatedValues.curp}`;

                setInformationPatient({
                    value: _id,
                    label: name_patient
                });

                await handleGetInformationPatient(_id);

                await searchAsync();

                toggle();

                createSweet(
                    "create",
                    "success",
                    "Paciente",
                    "Se actualizaron correctamente los datos"
                );
            }

        } catch (error) {
            console.error(error);
        }

        setLoading(false);
    };

    // ? CONFIGURATION HISTORIC PATIENT
    const getModifiedHistoricalFields = (original, updated, configuration, _id) => {

        if (!original) return [];

        const changes = [];

        configuration.forEach(config => {

            if (config.historical === true) {

                const field = config?.field;
                const field_name = config?.field_name

                const originalValue = original[field] ?? "";
                const newValue = updated[field] ?? "";

                if (originalValue !== newValue) {
                    changes.push({
                        site: "Catalógo de pacientes",
                        url: "/api/Patient/UpdateShort",
                        method: "UPDATE",
                        id_patient: _id,
                        field_name,
                        original_information: originalValue,
                        updated_information: newValue,
                        action_delete: false
                    });
                }
            }
        });

        return changes;
    };


    // ? LIST PATIENT
    useEffect(() => {

        let _list_patients = [];

        results.forEach(_patient => {
            let visibleTable = true;

            _list_patients.push({
                id_patient: _patient.id_patient,
                id_gender: _patient.id_gender,
                id_state: _patient.id_state_patient,
                id_municipality: _patient.id_municipality_patient,
                id_blood_type: _patient.id_blood_type,
                id_social_gender: _patient.id_social_gender,
                id_tax_regime: _patient.id_tax_regime,
                id_use_cfdi: _patient.id_use_cfdi,
                code: _patient.code,
                paternal_surname: _patient.paternal_surname,
                maternal_surname: _patient.maternal_surname,
                name: _patient.name,
                name_gender: _patient.id_gender === 1 ? "FEMENINO" : "MASCULINO",
                birthday: _patient.birthday,
                age: _patient.age,
                curp: _patient.curp,
                phone: _patient.phone,
                email: _patient.email,
                address: _patient.address_patient,
                cp: _patient.cp_patient,
                colony: _patient.colony_patient,
                membership: _patient.membership,
                name_state: _patient.name_state_patient,
                name_municipality: _patient.name_municipality_patient,
                visibleTable: visibleTable,
                unique_uuid: _patient.unique_uuid,
                qr_unique_id: _patient.qr_unique_id,
                rfc: _patient.rfc,
                type_person: _patient.type_person,
                name_social_gender: _patient.name_social_gender,
                name_tax_regime: _patient.name_tax_regime,
                name_use_cfdi: _patient.name_use_cfdi,
                name_blood_type: _patient.name_blood_type,
                matricula_buap: _patient.matricula_buap,
                nss: _patient.nss,
                expedient_number: _patient.expedient_number,
                whatsapp_numbers: _patient.whatsapp_numbers,
                creation_date: _patient.creation_date,
                responsible_for_creating: _patient.responsible_for_creating,

            });
        });

        setListPatients(_list_patients);
        setListPatientsData(results);

    }, [results]);

    useEffect(() => {
        searchAsync();
    }, [debounceValue]);

    useEffect(() => {
        searchAsync();
    }, [filters]);


    // ? CONFIGURATION  PATIENT HISTORY
    const [modalviewHistoric, setModalviewHistoric] = useState(false);
    const [dataInfo, setDataInfo] = useState([])
    const [loadingView, setLoadingView] = useState(false)
    const [labelPatient, setLabelPatient] = useState("")

    const [labelCreate, setLabelCreate] = useState("")
    const [labelResponsible, setLabelResponsible] = useState("")



    const toggleHistoric = () => {
        setModalviewHistoric(!modalviewHistoric);
    }


    const handleViewPatient = async (_id_patient, _patient, _creation_date, _responsible_for_creating) => {

        setLabelPatient(_patient)
        setLabelCreate(_creation_date)
        setLabelResponsible(_responsible_for_creating)

        const response = await getViewHistorical(_id_patient);

        if (response.code === 200) {
            setDataInfo(response.data);
        } else {
            setDataInfo([]);
        }


        setLabelPatient(_patient);
        toggleHistoric();
    };












    //#region GLOBAL REQUEST
    const _handleRequest = async (method, methodUrl, nameMethod, body = null, isMultipartForm = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            if (isMultipartForm !== null && isMultipartForm) {
                requestOptions = {
                    ...requestOptions,
                    body: body
                }
            }
            else {
                requestOptions = {
                    ...requestOptions,
                    body: JSON.stringify(body)
                };
            }
        }

        const response = await sendRequest(requestOptions, methodUrl, ((isMultipartForm !== null && isMultipartForm) ? "multipart/form-data" : "application/json"));
        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, _handleRequest);
        }
        else if (response.code === 404) {
            if (methodUrl === 'WorkOrder/PreviewAutorization') {


            }
            else {
                createSweet("warning", "warning", nameMethod, response.data.msg);
            }
        }
        else if (response.code === 409) {
            createSweet(nameMethod, response.data.msg, "error");
        }
        else if (response.code === 500) {
            if (methodUrl = 'Patient/UpdateShort') {
                createSweet("warning", "warning", nameMethod, "Verifica que los campos requeridos estén correctos")
            }
            else {
                createSweet("error", "error", nameMethod, nameMethod, "Ocurrio un error en el servidor");
            }

        }
        else {
            createSweet("warning", "warning", nameMethod, response.data.msg);
        }

        return null;
    }

    //#endregion

    const handleDateB = (birthday) => {
        if (birthday === '') {
            formValues.birthday = '';
            formValues.age = '';
            handleUpdateValues({
                ...formValues,
                age: '',
                birthday: ''
            });
            return;
        }

        const birthDate = new Date(birthday);

        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const today = new Date(currentYear, currentDate.getMonth(), currentDate.getDate());

        const day = String(birthDate.getDate()).padStart(2, '0');
        const month = String(birthDate.getMonth() + 1).padStart(2, '0');
        const year = birthDate.getFullYear();

        const hasBirthdayPassedThisYear = today >= new Date(currentYear, birthDate.getMonth(), birthDate.getDate());
        const age = hasBirthdayPassedThisYear ? currentYear - year : currentYear - year - 1;

        formValues.birthday = birthday;
        formValues.age = age;

        handleUpdateValues({
            ...formValues,
            age,
            birthday
        });
    };


    const getAge = (ageInput) => {
        if (ageInput === '') {
            formValues.age = '';
            formValues.birthday = '';
            handleUpdateValues({
                ...formValues,
                age: '',
                birthday: ''
            });
            return;
        }

        ageInput = Number(ageInput);
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const birthYear = currentYear - ageInput;

        const birthDate = new Date(birthYear, 0, 1);

        const today = new Date(currentYear, currentDate.getMonth(), currentDate.getDate());

        const hasBirthdayPassedThisYear = today >= new Date(currentYear, birthDate.getMonth(), birthDate.getDate());

        const actualAge = hasBirthdayPassedThisYear ? ageInput : ageInput - 1;

        const year = birthDate.getFullYear();
        const month = String(birthDate.getMonth() + 1).padStart(2, '0');
        const day = String(birthDate.getDate()).padStart(2, '0');
        const formattedDateForInput = `${year}-${month}-${day}`;

        formValues.birthday = formattedDateForInput;
        formValues.age = actualAge;


        handleUpdateValues({
            ...formValues,
            age: actualAge,
            birthday: formattedDateForInput
        });
    };

    //#region Excel Patient
    const exportExcelPatient = async () => {
        setLoadingExport(true);

        const response = await _handleRequest(
            "GET",
            "Patient/ListPatient?EnablePagination=false",
            "Exportar Pacientes"
        );

        const pacientes = response?.results ?? response?.data?.results ?? [];

        if (!pacientes.length) {
            createSweet("warning", "warning", "No hay datos para exportar.");
            return;
        }

        const _report = pacientes.map((p, index) => ({
            Nombre: p.name || "-----",
            "Apellido Paterno": p.paternal_surname || "-----",
            "Apellido Materno": p.maternal_surname || "-----",
            Género: p.name_gender || "-----",
            "F. Nacimiento": p.birthday || "-----",
            Edad: p.age || "-----",
            Curp: p.curp || "-----",
            Estado: p.name_state_patient || "-----",
            Municipio: p.name_municipality_patient || "-----",
            Teléfono: p.phone || "-----",
            Correo: p.email || "-----",
            RFC: p.rfc || "-----",
            Régimen: p.name_tax_regime || "-----",
            cfdi: p.name_use_cfdi || "-----",

        }));

        const XLSX = await import("xlsx");

        const worksheet = XLSX.utils.json_to_sheet(_report);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Pacientes");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const dataBlob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Listado_Pacientes.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setLoadingExport(false);

    };

    // #endregion



    const handleWhatsappChange = (e) => {
        const value = e.target.value;

        if (!/^[0-9,\s]*$/.test(value)) return;

        handleInputChange(e);
    };


    const validateWhatsapp = () => {
        const value = formValues.whatsapp_numbers || "";

        if (value.trim() === "") {
            setFieldErrors(prev => ({
                ...prev,
                whatsapp_numbers_valid: false
            }));
            return;
        }

        const numbers = value
            .split(",")
            .map(n => n.trim())
            .filter(n => n !== "");

        const invalid = numbers.some(n => n.length !== 10);

        setFieldErrors(prev => ({
            ...prev,
            whatsapp_numbers_valid: invalid
        }));
    };


    //#region TRANFER PATIENT

    const [showConfirm, setShowConfirm] = useState(false);
    const [modalTransfer, setModalTransfer] = useState(false);
    const [isPatientSelected, setIsPatientSelected] = useState(true);

    const [formValuesPatient, setFormValuesPatient] = useState({
        idPatientOrigin: 0,
        idPatientDestination: 0
    });

    const [searchPatientState, setSearchPatientState] = useState("");
    const [searchKey, setSearchKey] = useState(0);
    const [workOrderPatientCount, setWorkOrderPatientCount] = useState(0);
    const [errorTransferPatient, setErrorTransferPatient] = useState({
        origin: "",
        destiny: ""
    });

    const [searchPatientOrigin, setSearchPatientOrigin] = useState("");
    const [searchPatientDestination, setSearchPatientDestination] = useState("");

    const {
        idPatientOrigin,
        idPatientDestination,
        namePatientOrigin,
        namePatientDestination
    } = formValuesPatient;

    const openDialogTransfer = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModalTransfer(true);
    };


    const closeTransferPatient = () => {
        setModalTransfer(false);
        setShowConfirm(false);
        setFormValuesPatient({
            idPatientOrigin: 0,
            idPatientDestination: 0,
            namePatientOrigin: "",
            namePatientDestination: ""
        });
        setSearchPatientState("");
        setSearchKey(0);
        setWorkOrderPatientCount(0);
        setErrorTransferPatient({
            origin: "",
            destiny: ""
        });
        setSearchPatientOrigin("");
        setSearchPatientDestination("");
    };


    const handleCreateTransferPatient = () => {
        setMethod("create");
        setModalTitle("Transferir ordenes de trabajo a nuevo paciente");
        openDialogTransfer("Transferir ordenes de trabajo", "create");
    }

    const getPatientNameById = async (id) => {
        if (!id) return "";

        const patientLocal = listPatientsData.find(p => p.id_patient === Number(id));

        if (patientLocal) {
            return `${patientLocal.name} ${patientLocal.paternal_surname} ${patientLocal.maternal_surname}`;
        }

        const response = await sendRequest(
            { method: "GET" },
            `Patient/FindPatientId/${id}`
        );

        if (response.code === 200) {
            const p = response.data;
            return `${p.name} ${p.paternal_surname} ${p.maternal_surname}`;
        }

        return "";
    };

    useEffect(() => {
        const loadName = async () => {
            if (idPatientOrigin) {
                const name = await getPatientNameById(idPatientOrigin);

                setFormValuesPatient(prev => ({
                    ...prev,
                    namePatientOrigin: name
                }));
            }
        };

        loadName();
    }, [idPatientOrigin]);

    useEffect(() => {
        const loadName = async () => {
            if (idPatientDestination) {
                const name = await getPatientNameById(idPatientDestination);

                setFormValuesPatient(prev => ({
                    ...prev,
                    namePatientDestination: name
                }));
            }
        };

        loadName();
    }, [idPatientDestination]);


    const handleSelectChangePatient = (option, type) => {

        const id = option?.target?.value ?? 0;

        setFormValuesPatient(prev => ({
            ...prev,
            ...(type === "origin"
                ? { idPatientOrigin: id }
                : { idPatientDestination: id }
            )
        }));
    };


    const handleTransferPatient = async (confirmed = false) => {

        const isValid = runValidation();
        if (!isValid) return;

        if (!confirmed) {
            setShowConfirm(true);
            return;
        }

        let requestOptions = {
            method: 'POST',
        };

        const response = await sendRequest(
            requestOptions,
            `Patient/TransferPatient/${idPatientOrigin}/${idPatientDestination}`
        );

        console.log(response);

        const message = response?.msg || response?.data?.msg || "Error inesperado";

        if (response.code === 200) {
            createSweet("create", "success", "Éxito", message);
            closeTransferPatient();
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, () => handleTransferPatient(true));
        }
        else if (response.code === 409 || response.code === 500) {
            createSweet("error", "error", "Error", message);
        }
        else {
            createSweet("error", "error", "Transferencia", "Error al transferir");
        }

        setShowConfirm(false);
    };

    const getWorkOrderPatientCount = async (id) => {
        if (!id) return;

        setLoadingCount(true);

        let requestOptions = {
            method: 'GET'
        };

        const response = await sendRequest(
            requestOptions,
            `Patient/GetWorkOrdersCount/${id}`
        );

        if (response.code === 200) {
            setWorkOrderPatientCount(response.data);
        }

        setLoadingCount(false);
    };

    // useEffect(() => {
    //     if (idPatientOrigin) {
    //         setWorkOrderPatientCount(0); 
    //         getWorkOrderPatientCount(idPatientOrigin);
    //     } else {
    //         setWorkOrderPatientCount(0);
    //     }
    // }, [idPatientOrigin]);



    const validateTransferPatient = () => ({
        origin: !Number(idPatientOrigin) && "Selecciona un paciente de origen",
        destiny: !Number(idPatientDestination) && "Selecciona un paciente destino",
        same:
            idPatientOrigin &&
            idPatientDestination &&
            Number(idPatientOrigin) === Number(idPatientDestination) &&
            "Los Pacientes no pueden ser iguales"
    });

    const runValidation = () => {
        const validation = validateTransferPatient();

        const newErrors = {
            origin: validation.origin || validation.same || "",
            destiny: validation.destiny || validation.same || ""
        };

        setErrorTransferPatient(newErrors);

        return !newErrors.origin && !newErrors.destiny;
    };

    const handleShowConfirmPatient = () => {
        console.log("VALIDANDO:", formValuesPatient);

        const isValid = runValidation();

        if (isValid) {
            setShowConfirm(true);
        }
    };


    //#endregion


    useEffect(() => {
        if (idPatientOrigin) {
            getWorkOrderPatientCount(idPatientOrigin);
        }
    }, [idPatientOrigin]);

    return {
        // ? ACTIONS OF THE MODAL
        modal, modalTitle, method, loading, toggle,

        // ?MODELS
        isInvoiceService, setIsInvoiceService, viewNewSocialGender, setViewNewSocialGender,

        // ? CATALOGS
        listPatients, listStates, listMunicipalities, listBloodType,
        listTaxRegime, listUseCfdi, listSocialGender,

        // ? FIELD
        id_gender, id_state, id_municipality, id_blood_type, id_social_gender, id_tax_regime,
        id_use_cfdi, rfc, type_person, code, paternal_surname, maternal_surname, name, birthday, age,
        curp, address, cp, colony, phone, email, membership, cardnumber, new_social_gender, handleDateB,
        getAge, matricula_buap, nss, expedient_number, whatsapp_numbers,

        // ? ACTIONS OF THE INPUTS
        handleInputChange, handleSelectValues, handleDate, handleSearch, handleCreate, handleChangeState,
        handleChangeTypePerson, handleChangeTaxRegime,
        handleUpdate, handleDelete, handleChangeSocialGender,

        // ? SAVE METHODS
        saveCreatePatient, saveDelete, saveUpdatePatient,

        // ? PAGINATION AND FILTER TABLE
        goNextPage, goPreviousPage, goToPage, actualPage, totalPages, prevPage, nextPage, totalRecords,
        exportExcelPatient, loadingExport, closeModalPatient, searchQuery, handleClearFilter,
        filtersForm, setFiltersForm,

        // ? DYNAMIC FORM
        listConfiguration, fieldErrors,

        // ? CONFIGURATION 
        handleViewPatient, modalviewHistoric, dataInfo, toggleHistoric, loadingView, labelPatient, handleWhatsappChange, validateWhatsapp,
        showConfirm, modalTransfer, handleCreateTransferPatient, closeTransferPatient, setShowConfirm, handleSelectChangePatient,
        setIsPatientSelected, isPatientSelected, setSearchPatientState, searchPatientState, formValuesPatient, setSearchKey, searchKey,

        handleShowConfirmPatient, getWorkOrderPatientCount, handleTransferPatient, errorTransferPatient, workOrderPatientCount,
        namePatientDestination, namePatientOrigin,
        setSearchPatientDestination, searchPatientDestination, setSearchPatientOrigin, searchPatientOrigin, loadingCount,

        labelCreate, labelResponsible




    }
}
